import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { MenuItem, SortEvent } from 'primeng/api';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Entityservice } from './entityservice';
import { ExceldownloadComponent } from 'src/app/views/directives/exceldownload/exceldownload.component';
import Swal from 'sweetalert2';
import { UploadexcelformatComponent } from 'src/app/views/directives/uploadexcelformat/uploadexcelformat.component';
import { Utilityservice } from '../../utility/utilityservice.service';
import { GlobalMessage } from '../../utility/modals';
import { EntitymodalComponent } from '../../directives/entitymodal/entitymodal.component';
import { Table } from 'primeng/table';
import { PagehelpmodalService } from '../../directives/pagehelpmodal/pagehelpmodal.service';
import { LegalmodifyentitymodalComponent } from '../../directives/legalmodifyentitymodal/legalmodifyentitymodal.component';
import { BulkexceluploadComponent } from '../../directives/bulkexcelupload/bulkexcelupload.component';

@Component({
  selector: 'app-entity',
  templateUrl: './entity.component.html',
  styleUrls: ['./entity.component.css']
})
export class EntityComponent implements OnInit {
  @ViewChild('dt') dt: Table;
  tableData: any[] = [];
  selectedItem: MenuItem | null = null;
  commonScrollHeight = '';
  searchText: string;
  ref: DynamicDialogRef | undefined;
  first2: number = 0;
  rows2: number = 10;
  message: GlobalMessage = new GlobalMessage()
  totalRecords: number = 0;
  options = [];
  paginatorArray = []
  visible: boolean = false;
  excel_paragraph = '';
  templatedownloadtext = '';
  exceldownloadModal = false;
  downloadformate = false;
  position = 'top';
  cols = [];
  _selectedColumns = [];
  sortfield = 'companyname';

  searchcolumns = [];
  currentPageIndex: number = 0;
  companyId: number;
  deleteModal = false;
  selectedEntity: string = "";
  CSRFToken = '';
  orgType = "";
  orgId = "";
  userRole = "";
  limitedAccess = "N";
  isSupportAdmin = "";
  downloadRight = "";
  isOrgAdmin = "";
  groupList = [];
  organisationList = [];
  selectedGroupId: string = '';
  selectedOrgId: string = '';
  currentNumberOfCompany: number;
  noOfCompany: number;
  rowsize: number = 10;
  tablecount: number = 0;
  parentdata: any;
  searchTerm: string = ''; 
  
  constructor(public router: Router, public dialogService: DialogService,
    private entityservice: Entityservice, public utilityservice: Utilityservice, public PagehelpmodalService: PagehelpmodalService) {
    this.excel_paragraph = this.message.downloadexcel_text;
    this.templatedownloadtext = this.message.excelformate_text

  }

  ngOnInit() {
    this.commonScrollHeight = this.utilityservice.updateScrollHeight();
    this.getList();
    //this.dynamiccols();
    this.getConfiguration();
    this.gettoken();

  }
  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.commonScrollHeight = this.utilityservice.updateScrollHeight();
  }
  dynamiccols() {
    this.cols = [
      { field: "companyid", header: "Entity Id", type: 'text', sort: true, filter: true, width: '20px', isChecked: true, class: 'headerid' },
      { field: "companyname", header: "Entity", type: 'text', sort: true, filter: true, width: '20px', isChecked: true, class: 'otherheader' },
      { field: "companyinitial", header: "Entity Initial", type: 'text', sort: true, filter: true, width: '20px', isChecked: true, class: 'otherheader' },
      { field: "comapnytypename", header: "Entity Type", type: 'text', sort: true, filter: true, width: '20px', isChecked: true, class: 'otherheader' },
      { field: 'cinnumber', header: 'CIN Number', type: 'text', sort: true, filter: true, width: '2px !important', isChecked: true, class: 'otherheader' },
      { field: "dispalyasendmail", header: "Send Mail", type: 'text', sort: true, filter: true, width: '20px', isChecked: true, class: 'otherheader' },
      { field: "displayInoperative", header: "Inoperative", type: 'text', sort: true, filter: true, width: '20px', isChecked: true, class: 'otherheader' },
      { field: "createdby", header: "Created By", type: 'text', sort: true, filter: true, width: '20px', isChecked: true, class: 'otherheader' },
      { field: "createdon", header: "Created On", type: 'date', sort: true, filter: true, width: '20px', isChecked: true, class: 'otherheader' },
      { field: "activeflag", header: "Status", type: 'text', sort: false, filter: false, width: '20px', isChecked: true, class: 'otherheader' },

    ]
    if (this.orgType === 'P' || this.orgId == "0") {
      this.cols.splice(3, 0, {
        field: "groupname", header: "Client Group", type: 'text', sort: true, filter: true, width: '20px', isChecked: true, class: 'otherheader'
      });
    }
    this._selectedColumns = this.cols;
    this.searchcolumns = this.cols.map(e => e.field);

  }
  showDialog() {
    let payload = {}
    const width = this.utilityservice.isMobile() ? '90vw' : 'auto';
    this.ref = this.dialogService.open(ExceldownloadComponent, {
      header: "Excel Download",
      width: width,
      height: '10rem',
      data: { excelname: "Entity_Master_Data.xlsx", downloadapi: 'common/entity/entityDataExcel', method: 'get', message: this.excel_paragraph, payload: payload },
      contentStyle: { overflow: 'hidden' },
      baseZIndex: 10000,
    });
  }


  showUploadFormatDialog() {
    this.ref = this.dialogService.open(UploadexcelformatComponent, {
      header: "Download Excel Format",
      data: {},
      contentStyle: { overflow: 'hidden' },
      baseZIndex: 10000,
      maximizable: true,
      position: 'top'
    });
    this.ref.onClose.subscribe(() => {
      // this.commonservice.downloadObservable.next("")
    });
  }

  getList() {
    const currentPageSize = this.rowsize;
    const payload: any = {};
    if (this.orgType === 'P' && this.selectedGroupId) {
      payload.groupid = this.selectedGroupId;
    }
    if (this.userRole == "0" && this.selectedOrgId) {
      payload.orgid = this.selectedOrgId
    }
    this.entityservice.getall_list(payload).subscribe((data) => {
      this.tableData = data;
      this.tableData.forEach(item => {
        item.displayInoperative = item.inoperative === 'Y' ? 'Yes' : 'No';
        item.dispalyasendmail = item.sendmail === 'Y' ? 'Yes' : 'No';
      });
      // this.options=  this.utilityservice.getOptionDropdown(data.length);
      // this.paginatorArray=this.options.map(e=>e.value)

      this.options = this.utilityservice.getOptionDropdown(data.length) || [];
      this.paginatorArray = this.options.map((e: any) => +e.value);
      if (!this.paginatorArray.includes(currentPageSize)) {
        this.paginatorArray.push(currentPageSize);
        this.paginatorArray.sort((a, b) => a - b);
      }
      this.rowsize = currentPageSize;
      this.totalRecords = this.tableData.length;
      this.tablecount = data.count ?? data.length;
      setTimeout(() => {
        if (this.dt) {
          this.dt.first = this.currentPageIndex;
        }
      }, 0);
    });
  }


  //Download users Master Excel

  excelUploadFormat() {
    this.entityservice.excelUploadFormat().subscribe((response: Blob) => {
      const blob = new Blob([response],
        { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'Entity_ExcelUpload-Format.xlsx';
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      this.downloadformate = false;
      Swal.fire('File downloaded successfully!', '', 'success');
    }, error => {
      Swal.fire('Something went wrong', '', 'error');

    })
      ;
  }
  addnew(title, data) {
    let details = {};
    let extraDetails = {};
    this.currentPageIndex = this.dt?.first || 0;
    extraDetails =
    {
      "currentNumberOfCompany": this.currentNumberOfCompany,
      "noOfCompany": this.noOfCompany,
      "limitedAccess": this.limitedAccess
    }
    if (title === 'Modify Entity') {
      this.entityservice.getDataView_byId(data.companyid, data.orgid).subscribe(res => {
        details = res;
        this.ref = this.dialogService.open(EntitymodalComponent, {
          header: title,
          width: '70vw',
          height: 'auto',
          data: { title: title, datas: details, "orgType": this.orgType, "orgId": this.orgId, "userRole": this.userRole, "extraDetails": extraDetails },
          contentStyle: { overflow: 'auto' },

        });
        this.ref.onClose.subscribe((res) => {
          // if (res == 'Save') {
          this.getList();
          this.getConfiguration();
          setTimeout(() => {
            if (this.dt) this.dt.first = this.currentPageIndex;
          }, 50);
          // }
        });
      })
    } else if (title === 'Modify Legal Name of Entity') {

      Swal.fire({
        //title: 'Are you sure?',
        text: 'Are you sure you want to change Entity Legal Name?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, I am sure',
        cancelButtonText: 'No, Cancel it',
        confirmButtonColor: '#2f5fa8',
        cancelButtonColor: '#d33'
      }).then((result) => {

        if (result.isConfirmed) {

          this.entityservice.getDataView_byId(data.companyid, data.orgid).subscribe(res => {
              details = res;
              this.ref = this.dialogService.open(LegalmodifyentitymodalComponent, {
                header: title,
                width: '70vw',
                height: 'auto',
                data: { title: title, datas: details },
                contentStyle: { overflow: 'auto' },
              });

              this.ref.onClose.subscribe((res) => {
                this.getList();
                this.getConfiguration();
                setTimeout(() => {
                  if (this.dt) this.dt.first = this.currentPageIndex;
                }, 50);
              });
            });
        }
      });
    }

    else if (title === 'View Entity') {
      this.entityservice.getDataView_byId(data.companyid, data.orgid).subscribe(res => {
        let details = res;
        this.ref = this.dialogService.open(EntitymodalComponent, {
          header: title,
          width: '70vw',
          height: 'auto',
          data: {
            title: title,
            datas: details,
            orgType: this.orgType,
            orgId: this.orgId,
            userRole: this.userRole,
            onlyView: true,
            "extraDetails": extraDetails
          },
          contentStyle: { overflow: 'auto' },
        });
      });
    }


    else {
      details = {}


      this.ref = this.dialogService.open(EntitymodalComponent, {
        header: title,
        width: '70vw',
        height: 'auto',
        data: { title: title, datas: details, "orgType": this.orgType, "orgId": this.orgId, "userRole": this.userRole, "extraDetails": extraDetails },
        contentStyle: { overflow: 'auto' },

      });
      this.ref.onClose.subscribe((res) => {

        this.getList();
        this.getConfiguration();
        setTimeout(() => {
          if (this.dt) this.dt.first = this.currentPageIndex;
        }, 50);
      });
    }
  }
  handlePageChange(event: any) {
    this.rowsize = event.rows;
    this.currentPageIndex = event.first;
  }



  excelDownload() {
    const payload = {
      groupId: this.selectedGroupId,
      orgId: this.selectedOrgId
    };
    this.entityservice.entityDataExcel(payload).subscribe((response: Blob) => {
      const blob = new Blob([response],
        { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'Entity Master.xlsx';
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      this.exceldownloadModal = false;
      Swal.fire('File downloaded successfully! ', '', 'success');
    }, error => {
      Swal.fire('Something went wrong', '', 'error');
    });
  }


  entityDataExcel() {
    const payload = {
      groupId: this.selectedGroupId,
      orgId: this.selectedOrgId
    };
    this.entityservice.entityDataExcel(payload).subscribe((response: Blob) => {
      const blob = new Blob([response],
        { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'Entity_Master_Data.xlsx';
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      this.visible = false;
      Swal.fire('File downloaded successfully!', '', 'success');
    }, error => {
      Swal.fire('Something went wrong', '', 'error');

    })
      ;
  }


  getConfiguration(): void {
    this.entityservice.getConfiguration().subscribe(
      (response) => {
        if (response && response.length > 0) {
          this.orgType = response[0]?.orgType;
          this.isOrgAdmin = response[0]?.isOrgAdmin;
          this.limitedAccess = response[0]?.tssprtlimitedaccess;
          this.userRole = response[0]?.userRole;
          this.orgId = response[0]?.orgId;
          this.isSupportAdmin = response[0]?.isSupportAdmin;
          this.downloadRight = response[0]?.downloadRight;
          this.currentNumberOfCompany = response[0]?.currentNumberOfCompany;
          this.noOfCompany = response[0]?.noOfCompany;

          this.dynamiccols();
          if (this.orgType == "P") {
            this.getGroup();
          }
          if (this.userRole == "0") {
            this.getOrganisation();
          }
        }
      },
      (error) => {
        console.error('Error fetching configuration:', error);
      }
    );
  }

  openDeleteModal(data) {
    this.companyId = data.companyid;
    this.selectedEntity = data.companyname;
    this.deleteModal = true;

  }

  gettoken() {
    this.CSRFToken = '';
    this.utilityservice.getCSRFtoken().subscribe(res => {
      this.CSRFToken = res.csrf;
    }, error => {
      Swal.fire(error.error.message, '', 'error');
    });
  }

  // deleteEntity(companyId: any) {
  //   this.gettoken();
  //   const payload = {
  //     companyId: companyId,
  //     csrftoken: this.CSRFToken,
  //   };
  //   this.entityservice.deleteEntity(payload).subscribe(
  //     (response) => {
  //       Swal.fire('Entity deleted successfully!', '', 'success');
  //       this.getList(this.sortfield, this.sortorder);
  //       this.getConfiguration();
  //       this.deleteModal=false;
  //     },
  //     (error) => {
  //       console.error('Error response:', error);
  //       Swal.fire('Error!', 'Something went wrong while deleting.', 'error');
  //     }
  //   );
  // }

  deleteEntity(companyId: any) {
    this.utilityservice.getCSRFtoken().subscribe(
      res => {
        const payload = {
          companyId: companyId,
          csrftoken: res.csrf,
        };
        this.entityservice.deleteEntity(payload).subscribe({
          next: () => {
            Swal.fire('Entity deleted successfully!', '', 'success');
            this.getList();
            this.getConfiguration();
            this.deleteModal = false;
          },
          error: (error) => {
            console.error('Error response:', error);
            Swal.fire('Error!', 'Something went wrong while deleting.', 'error');
          }
        });
      },
      err => {
        Swal.fire(err.error.message || "CSRF Token Error", '', 'error');
      }
    );

  }

  getGroup() {
    this.entityservice.getGroup().subscribe(res => {
      this.groupList = res;
      this.groupList.unshift({ groupid: '', groupname: 'Select' });
    });
  }
  getOrganisation() {
    this.entityservice.getOrganisation().subscribe(res => {
      this.organisationList = res;
      this.organisationList.unshift({ orgid: '', name: 'Select' });
    });
  }
  onGroupChange(groupId: string) {
    this.selectedGroupId = groupId;
    this.getList();
  }

  onOrgChange(orgId: string) {
    this.selectedOrgId = orgId;
    this.getList();
  }


  openexceluploadmodal() {
    let payload = {}
    this.parentdata = {};
    this.parentdata = {
      title: 'Entity Data Upload',
      apdownloadapi: 'common/entity/uploadexcel', 
      sucessmessage: 'Entity Data uploaded successfully!', 
      message:`You should have downloaded the Excel format for Entity creation. You should have updated all the required information. The Excel file you choose will be uploaded and verified for accuracy. If there are no errors, the hierarchies will be created. Else, the errors will be displayed on the screen.`,
      master: 'Entity'
    }
    this.ref = this.dialogService.open(BulkexceluploadComponent, {
      header: this.parentdata.title,
      width: '70%',
      height: '40',
      data: {
        uploadapi: this.parentdata.apdownloadapi,
        method: 'Post', message: this.parentdata.message, payload: payload, master: this.parentdata.master
      },
      contentStyle: { overflow: 'hidden' },
      position: 'center',
      style: { 'max-width': '100%', 'min-width': '60%' }
    }),
      this.ref.onClose.subscribe(res => {
        if (res == 'uploaded') {
          this.getList();
        }
      })
  }

  customSort(event: SortEvent) {
    event.data.sort((data1, data2) => {
      let value1 = data1[event.field];
      let value2 = data2[event.field];
      let result = 0;

      // Handle null values
      if (value1 == null && value2 == null) return 0; // Both are null
      if (value1 == null) return event.order === 1 ? 1 : -1; // value1 is null
      if (value2 == null) return event.order === 1 ? -1 : 1; // value2 is null

      // Determine result based on field type
      if (typeof value1 === 'string' && typeof value2 === 'string') {
        if (event.field === 'createdon') {
          // Parse date strings into Date objects
          const date1 = new Date(value1.split('-').reverse().join(',')); // Convert "DD-MMM-YYYY" to "YYYY,MMM,DD"
          const date2 = new Date(value2.split('-').reverse().join(','));
          result = date1.getTime() - date2.getTime(); // Compare timestamps
        } else {
          // Handle departmentname and other strings
          if (event.field === 'departmentname') {
            result = value1.trim().toLowerCase().localeCompare(value2.trim().toLowerCase());
          } else {
            result = value1.localeCompare(value2);
          }
        }
      } else if (typeof value1 === 'number' && typeof value2 === 'number') {
        // Numeric comparison
        result = value1 - value2;
      } else {
        // Fallback for mixed types or unexpected cases
        result = value1.toString().localeCompare(value2.toString());
      }

      return event.order === 1 ? result : -result;  // Adjust for ascending/descending order
    });
  }

  cleanRegExp(str: string): string {
    return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  highlight(input: string, searchstring: string | number): string {
    if (!searchstring) return input;
    const safeText = String(input ?? '');
    const safeSearch = this.cleanRegExp(String(searchstring));
    const re = new RegExp(safeSearch, 'gi');
    return safeText.replace(re, match => `<span class="highlightsearch">${match}</span>`);
  }

}


